import CardHeader from "@material-ui/core/CardHeader";
import styled from "styled-components";
import {
  visibilityLegend,
  icons,
  CHANGE_TAG_MODAL_STATUS,
  USER_TAGS,
  SYSTEM_TAGS,
  GET_SECOND_TAGS_DROPDOWN,
  GET_TAG_VALUES,
  SET_SECOND_TAG_VALUE,
  flexHeaders,
  allowedTypeSource,
  CVE_ID_INFO,
  severityColorMap,
} from "./NetSpaceConstant";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import ErrorIcon from "@material-ui/icons/Error";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { isEmpty, isNull } from "lodash";
import AlertBadge from "../../components/shared/Badge/AlertBadge";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import Paper from "@material-ui/core/Paper";
import NetSpaceUserTag from "./NetSpaceUserTag";
import Popup from "reactjs-popup";
import { useDispatch, useSelector } from "react-redux";
import { MenuItem } from "material-ui-core";
import Popper from "@material-ui/core/Popper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import AlertBadgeLabel from "../../components/shared/Badge/AlertBadgeLabel";
import { jiraTableHeaders } from "../MDRDashboard/mdrConstants";
import SensitivityBadge from "../../components/shared/Badge/SensitivityBadge";
import { useEffect, useRef, useState } from "react";
import { useGridApiContext } from "@mui/x-data-grid";

const MIN_CHIPS = 2;

const fallbackColors = [ "#ee4d3f", "#081981", "#ff9eb3", "#ffbf8c", "#0000"];

let fallbackIndex = 0;

export const getFallbackColor = () => {
  const color = fallbackColors[fallbackIndex % fallbackColors.length];
  fallbackIndex++;
  return color;
};

export const StyledCardHeader = styled(({ ...other }) => (
  <CardHeader {...other} />
))`
  & .MuiCardHeader-content {
    flex: 1 1 auto;
    width: 100%;
  }
  & .MuiTypography-h5 {
    font-size: 1rem;
    font-weight: bold;
  }
  @media (max-width: 1600px) {
    & .MuiTypography-h5 {
      font-size: 0.775rem;
      white-space: normal;
    }
    &.MuiCardHeader-root {
      padding-bottom: 5px;
    }
  }
  @media (max-width: 1800px) {
    & .MuiTypography-h5 {
      font-size: 0.875rem;
      white-space: normal;
    }
    &.MuiCardHeader-root {
      padding-bottom: 5px;
    }
  }
`;
export const sensitivityColor = (sensitivity) => {
  switch (sensitivity.toUpperCase()) {
    case "CRITICAL":
      return "#E22D1B";
    case "HIGH":
    case "NO":
      return "#FF2251";
    case "MEDIUM":
    case "UNKNOWN":
      return "#FF8429";
    case "LOW":
    case "YES":
      return "#081981";
    case "INFORMATIONAL":
      return "#11B7D6";
    default:
      return "#ffffff";
  }
};
export const alertColor = (sensitivity) => {
  switch (sensitivity.toUpperCase()) {
    case "CRITICAL":
      return "#E22D1B";
    case "HIGH":
      return "#FF2251";
    case "MEDIUM":
      return "#FFA135";
    case "LOW":
      return "#0A2AFF";
    case "INFORMATIONAL":
      return "#11B7D6";
    default:
      return "#ffffff";
  }
};
export const osTypesColors = (os) => {
  switch (os?.toUpperCase()) {
    case "WINDOWS":
      return "#0078D4";
    case "LINUX":
      return "#ff8429";
    case "MACOS":
      return "black";
    default:
      return getFallbackColor();
  }
};
export const sourceTypesColors = (sourceType) => {
  switch (sourceType?.toUpperCase()) {
    case "SENTINEL":
      return "#0078D4";
    case "NETWITNESS":
      return "#f4bc00";
    case "NMAP_FILE":
      return "#000000";
    case "MICROSOFT_SENTINEL":
      return "#11B7D6";
    default:
      return getFallbackColor();
  }
};

export const sensitivityColorDark1 = (sensitivity) => {
  switch (sensitivity.toUpperCase()) {
    case "CRITICAL":
      return "#B32114"; // darker red
    case "HIGH":
    case "NO":
      return "#CC1C41"; // darker pink-red
    case "MEDIUM":
    case "UNKNOWN":
      return "#E06610"; // darker orange
    case "LOW":
    case "YES":
      return "#0040A0"; // darker blue
    default:
      return "#cccccc";
  }
};
export const sensitivityColorDark2 = (sensitivity) => {
  switch (sensitivity.toUpperCase()) {
    case "CRITICAL":
      return "#7D170E"; // darkest red
    case "HIGH":
    case "NO":
      return "#991530"; // darkest pink-red
    case "MEDIUM":
    case "UNKNOWN":
      return "#994E17"; // darkest orange
    case "LOW":
    case "YES":
      return "#040D3F"; // darkest blue
    default:
      return "#999999";
  }
};

export const renderCriticality = (color) => {
  return <div className={`circle-dot ${color || "LOW"}`}></div>;
};
export const renderIsMonitored = (params) => {
  const { isMonitored } = params.row;
  const isActive = params.isActive;

  if (isMonitored === "NO") {
    return isActive ? <CancelIcon /> : <HighlightOffIcon />;
  }

  if (isMonitored === "UNKNOWN") {
    return isActive ? <ErrorIcon /> : <ErrorOutlineIcon />;
  }

  return isActive ? <CheckCircleIcon /> : <CheckCircleOutlineIcon />;
};
export const renderNull = () => {
  return <div className="emptyContainer">-</div>;
};
export const renderAlerts = (params) => {
  let param = {
    alert_count_critical: params?.value?.[0].critical || 0,
    alert_count_high: params?.value?.[0].high || 0,
    alert_count_medium: params?.value?.[0].medium || 0,
    alert_count_low: params?.value?.[0].low || 0,
  };
  return (
    <div className="inspect-alerts netspace-column">
      <AlertBadge parentprops={param} InspectContent={true} location="netSpace" />
    </div>
  );
};
export const renderHostIPFnWrapper =
  (dispatch, group = null) =>
  (params, view) => {
    const InspectContent = true;
    const row = params.row;

    const ips = row?.networks?.map((n) => n.ipv4).filter(Boolean) ?? [];

    if (!ips.length) return renderNull();

    const ipsShort = ips.slice(0, MIN_CHIPS);
    const remainingCount = ips.length - ipsShort.length;
    const renderIPs = view === "fullView" ? ips : ipsShort;

    return (
      <div className="inspect-alerts dataOwner">
        <Paper
          component="ul"
          className={
            InspectContent
              ? "chip-container alerts inspect-content"
              : "chip-container alerts"
          }
        >
          <div className="netSpaceTagsContainer">
            <div
              className={`cveId-container ${
                view === "fullView" ? "cveId-grid" : ""
              }`}
            >
              {renderIPs.map((ip) => (
                <div
                  key={ip}
                  className={
                    InspectContent
                      ? "alerts-container inspect-content-header"
                      : "alerts-container"
                  }
                >
                  <div className="squareBadge other tag tags" title={ip}>
                    <span
                      className={
                        view !== "fullView"
                          ? "squareBadge-text fullView"
                          : "squareBadge-text"
                      }
                    >
                      {ip}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            {/* +N exactly like CVE */}
            <div>
              {remainingCount > 0 &&
                view !== "fullView" &&
                imageCount(remainingCount)}
            </div>
          </div>
        </Paper>
      </div>
    );
  };
export const renderCVEId = (params, view, selectedSeverity = null) => {
  const InspectContent = true;
  const hostData = params?.row?.hostCveResponse || {};

  const criticalCves = hostData.criticalCves ?? [];
  const highCves = hostData.highCves ?? [];
  const mediumCves = hostData.mediumCves ?? [];
  const lowCves = hostData.lowCves ?? [];

  if (view !== "fullView") {
    const critical = criticalCves.length;
    const high = highCves.length;
    const medium = mediumCves.length;
    const low = lowCves.length;

    const total = critical + high + medium + low;

    if (total === 0) {
      return renderNull();
    }

    const cveRiskData = {
      sensitivity_count_critical: critical,
      sensitivity_count_high: high,
      sensitivity_count_medium: medium,
      sensitivity_count_low: low,
      total_sensitivity_count: total,
    };

    return (
      <div className="user-risk-container">
        <SensitivityBadge parentprops={cveRiskData} loc="netSpace" />
      </div>
    );
  }

  // ----------- FULL VIEW -----------
  const cveMap = new Map();

  const addToMap = (list, severity) => {
    list.forEach((id) => {
      if (id && !cveMap.has(id)) {
        cveMap.set(id.trim(), severity);
      }
    });
  };

  addToMap(criticalCves, "CRITICAL");
  addToMap(highCves, "HIGH");
  addToMap(mediumCves, "MEDIUM");
  addToMap(lowCves, "LOW");

  let allCveIds = Array.from(cveMap.keys());

  if (selectedSeverity) {
    allCveIds = allCveIds.filter((id) => cveMap.get(id) === selectedSeverity);
  }

  if (!allCveIds.length) {
    return renderNull();
  }

  const severityColorMap = {
    CRITICAL: "#e22d1b",
    HIGH: "#ff2251",
    MEDIUM: "#ff8421",
    LOW: "#081981",
  };

  return (
    <div className="inspect-alerts dataOwner">
      <Paper
        component="ul"
        className={
          InspectContent
            ? "chip-container alerts inspect-content"
            : "chip-container alerts"
        }
      >
        <div className="netSpaceTagsContainer">
          <div className="cveId-container cveId-grid">
            {allCveIds.map((id) => {
              const tagTxt = id.trim();
              const severity = cveMap.get(tagTxt);

              return (
                <div
                  key={id}
                  className={
                    InspectContent
                      ? "alerts-container inspect-content-header"
                      : "alerts-container"
                  }
                >
                  <div
                    className="squareBadge other tag tags"
                    title={tagTxt}
                    onClick={() => {
                      const url = CVE_ID_INFO(tagTxt);
                      window.open(url, "_blank", "noopener,noreferrer");
                    }}
                    style={{
                      cursor: "pointer",
                      backgroundColor: severityColorMap[severity],
                      color: "#fff",
                    }}
                  >
                    <span className="squareBadge-text">{tagTxt}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Paper>
    </div>
  );
};

export const renderCVEScore = (params) => {
  const cveScore = params?.row?.hostCveResponse?.highestScore?.toString();
  if (!isNull(cveScore) && !isEmpty(cveScore)) {
    return (
      <div className="host-name-container">
        <div className="host-name" title={cveScore}>
          {cveScore}
        </div>
      </div>
    );
  } else {
    return renderNull();
  }
};

export const renderCVESeverity = (params) => {
  const cve = params?.row?.hostCveResponse;

  if (cve) {
    const total =
      (cve.criticalCves?.length || 0) +
      (cve.highCves?.length || 0) +
      (cve.mediumCves?.length || 0) +
      (cve.lowCves?.length || 0);

    return total > 0 ? (
      <div className="inspect-alerts netspace-column">{formatNumberUS(total)}</div>
    ) : (
      renderNull()
    );
  }

  return renderNull();
};

export const renderHostMacAddress = (params) => {
  const macAddress = params?.row?.networks?.find((n) => n.mac)?.mac;

  return macAddress ? (
    <div className="host-name-container">
      <div className="host-name" title={macAddress}>
        {macAddress}
      </div>
    </div>
  ) : (
    renderNull()
  );
};

export const renderHostName = (params) => {
  const hostname = params?.row?.hostName;
  if (!isNull(hostname) && !isEmpty(hostname)) {
    return (
      <div className="host-name-container">
        <div className="host-name" title={hostname}>
          {hostname}
        </div>
      </div>
    );
  } else {
    return renderNull();
  }
};

export const renderHostTypesWithLetter = (view, pdetails, index) => {
  if (view !== "fullView") {
    return (
      <div key={index} className="netSpace-icon-text" title={pdetails.hostType}>
        <div className="circle greenCircle">
          <span className="circleText">
            {pdetails.hostType?.[0]?.toUpperCase()}
          </span>
        </div>
      </div>
    );
  } else {
    return (
      <div key={index} className="netSpace-icon-text" title={pdetails.hostType}>
        {pdetails.hostType}
      </div>
    );
  }
};

export const renderHostType = (params, view, isSmall) => {
  if (!isNull(params.row.ports) && !isEmpty(params.row.ports)) {
    const ports = params.row.ports;
    const displayPorts = ports.slice(0, MIN_CHIPS);
    const remainingCount = ports.length - displayPorts.length;
    const renderImages = view === "fullView" ? ports : displayPorts;

    return (
      <div className="inspect-alerts netSpace-container">
        {renderImages.map((pdetails, index) => {
          const icon = pdetails.icon;
          return icon ? (
            <div key={index} className="dataOwner">
              <img
                src={icon}
                alt={pdetails.hostType}
                title={pdetails.description}
                className="netSpace-icons"
              />
            </div>
          ) : (
            renderHostTypesWithLetter(view, pdetails, index)
          );
        })}
        <div>
          {remainingCount > 0 &&
            view !== "fullView" &&
            imageCount(remainingCount, "type")}
        </div>
      </div>
    );
  } else if (
    params?.row?.sourceType &&
    allowedTypeSource.includes(params?.row?.sourceType)
  ) {
    return (
      <div className="inspect-file-header dataOwner">
        <div title={params.row.type}>{params.row.type}</div>
      </div>
    );
  } else {
    return renderNull();
  }
};

const imageCount = (count, location) => {
  return (
    <div
      className={`circle ${location === "type" ? "greenCircle" : "oneDrive"}`}
    >
      <span className="circleText" title={count}>{`+${count}`}</span>
    </div>
  );
};

export const renderOS = (params) => {
  const icon = icons[params.row.os];
  const OSName = params.row.os || null;
  if (icon && !isNull(OSName)) {
    return (
      <div className="inspect-file-header dataOwner">
        <div title={OSName}>
          <img
            src={icon}
            alt={OSName}
            className={`dataOwner-icons netSpace netSpace-icons`}
          />
        </div>
      </div>
    );
  } else if (!isNull(OSName)) {
    return (
      <div className="inspect-file-header dataOwner txt-only">
        <div title={OSName}>{OSName}</div>
      </div>
    );
  } else {
    return renderNull();
  }
};

export const renderPorts = (params, view, isSmall) => {
  const InspectContent = true;
  if (!isNull(params.row.ports) && !isEmpty(params.row.ports)) {
    const ports = params.row.ports;
    const displayPorts = ports.slice(0, isSmall ? 1 : MIN_CHIPS);
    const remainingCount = ports.length - displayPorts.length;
    const renderPort = view === "fullView" ? ports : displayPorts;
    return (
      <>
        <div>
          {renderPort.map((pdetails) => {
            return (
              <div className="inspect-alerts dataOwner">
                <Paper
                  component="ul"
                  className={
                    InspectContent
                      ? "chip-container alerts inspect-content ports"
                      : "chip-container alerts"
                  }
                >
                  <div
                    className={
                      InspectContent
                        ? "alerts-container inspect-content-header"
                        : "alerts-container"
                    }
                  >
                    <div
                      className={`squareBadge ${pdetails.severity.toLowerCase()}`}
                      title={pdetails.port}
                    >
                      <span
                        className={
                          view !== "fullView"
                            ? "squareBadge-text fullView"
                            : "squareBadge-text"
                        }
                      >
                        {pdetails.hostType + ":" + pdetails.port}
                      </span>
                    </div>
                  </div>
                </Paper>
              </div>
            );
          })}
        </div>
        <div>
          {remainingCount > 0 &&
            view !== "fullView" &&
            imageCount(remainingCount, "type")}
        </div>
      </>
    );
  }
  return renderNull();
};

export const renderNames = (params, view, handleOpenPopup) => {
  if (params.row.userTags && params.row.userTags.length > 0) {
    const InspectContent = true;
    const MIN_CHIPS = 2;

    const userTags = params.row.userTags;
    const displayTags =
      view === "fullView" ? userTags : userTags.slice(0, MIN_CHIPS);
    const remainingCount = userTags.length - displayTags.length;

    return (
      <div className="inspect-alerts dataOwner">
        <Paper
          component="ul"
          className={
            InspectContent
              ? "chip-container alerts inspect-content"
              : "chip-container alerts"
          }
        >
          <div
            className={`cveId-container userTags ${
              view === "fullView" ? "cveId-grid" : ""
            }`}
          >
            {displayTags.map((p, index) => {
              const tagTxt = `${p.code}:${p.value}`;
              return (
                <div
                  key={index}
                  className={
                    InspectContent
                      ? "alerts-container inspect-content-header"
                      : "alerts-container"
                  }
                >
                  <div className={`squareBadge other tag tags`} title={tagTxt}>
                    <span className="squareBadge-text">{p.value}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </Paper>

        <div className="user-tags-button-container">
          {remainingCount > 0 &&
            view !== "fullView" &&
            imageCount(remainingCount, "type")}
          <div className="host-add-tag">
            <AddCircleOutlineIcon
              className="add-tag"
              onClick={(e) =>
                handleOpenPopup(e, params.row.userTags, params.row.nodeId)
              }
            />
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="inspect-alerts dataOwner">
        {renderNull()}
        <div className="host-add-tag">
          <AddCircleOutlineIcon
            className="add-tag"
            onClick={(e) =>
              handleOpenPopup(e, params.row.userTags, params.row.nodeId)
            }
          />
        </div>
      </div>
    );
  }
};

export const renderUserTagsWithHostTag = (params, group, dispatch, view) => {
  const handleOpenPopup = (e, tags, nodeId) => {
    e.stopPropagation();
    const payloadObj = {
      isTagModalOpen: true,
      selectedTagData: tags,
      selectedTagNodeId: nodeId,
    };
    if (group !== null) {
      payloadObj.updateTagGroup = group;
    }
    dispatch({
      type: CHANGE_TAG_MODAL_STATUS,
      payload: payloadObj,
    });
  };
  return (
    <div className="user-tags-container">
      {renderNames(params, view, handleOpenPopup)}
    </div>
  );
};

// helper to render a single tag
const renderTagItem = (text, view, InspectContent = true) => {
  return (
    <div
      className={
        InspectContent
          ? "alerts-container inspect-content-header"
          : "alerts-container"
      }
      key={text === "Sentinel" ? "S1" : text}
    >
      <div className={`squareBadge other tag tags`} title={text}>
        <span
          className={
            view !== "fullView"
              ? "squareBadge-text fullView"
              : "squareBadge-text"
          }
        >
          {text === "Sentinel" ? "S1" : text}
        </span>
      </div>
    </div>
  );
};

// common tag container
const renderTagContainer = (children, InspectContent = true) => {
  return (
    <div className="inspect-alerts dataOwner">
      <Paper
        component="ul"
        className={
          InspectContent
            ? "chip-container alerts inspect-content"
            : "chip-container alerts"
        }
      >
        {children}
      </Paper>
    </div>
  );
};

// common reusable render function
const renderTagList = (items, view, mapFn, inspectContent = false) => {
  if (!items || isEmpty(items)) {
    return renderNull();
  }

  const displayItems = items.slice(0, MIN_CHIPS);
  const remainingCount = items.length - displayItems.length;
  const renderList = view === "fullView" ? items : displayItems;

  return (
    <div className="netSpaceTagsContainer">
      {renderTagContainer(
        renderList.map((item) =>
          renderTagItem(mapFn(item), view, inspectContent),
        ),
        inspectContent,
      )}
      <div>
        {remainingCount > 0 &&
          view !== "fullView" &&
          imageCount(remainingCount, "type")}
      </div>
    </div>
  );
};

export const renderSource = (params, view) => {
  return renderTagList(params.row.sourceType, view, (src) => src, true);
};

export const renderTags = (params, view) => {
  return renderTagList(params.row.systemTags, view, (p) => `${p.value}`, true);
};

export const isFileProcessCompleted = (data) => {
  ["PROCESSED", "ERROR"].includes(data?.status?.code);
};

export const renderHeaderWithFilter =
  (
    headerName,
    field,
    isSelected,
    activeFilterField,
    handleFilterIconClick,
    isSmall,
    showFilter = true,
  ) =>
  () => {
    const isActive = isSelected || activeFilterField === field;

    const renderHeaderNameTitle = () => {
      if (jiraTableHeaders.includes(field)) {
        return "jiraTable";
      } else if (headerName === "Visibility") {
        return "visibility";
      } else {
        return "";
      }
    };

    return (
      <div
        className="tableHeaderCell header-hover-container"
        title={headerName}
      >
        <div
          className={
            headerName === "CVE Severity" || headerName === "CVE Score"
              ? "header-display nameShort"
              : "header-display"
          }
        >
          <span className={`header-title-netSpace ${renderHeaderNameTitle()}`}>
            {headerName === "Visibility" ? <VisibilityIcon /> : headerName}
          </span>

          {showFilter && (
            <div
              className="tableFilterIcon-netspace"
              onClick={(e) => {
                e.stopPropagation();
                handleFilterIconClick(e, field);
              }}
              title={headerName}
              role="button"
              tabIndex={0}
            >
              <img
                src="/sysGuardIcons/filter_list_notSelected.svg"
                alt="Filter icon"
              />
            </div>
          )}
        </div>
        {isActive && (
          <div className="selected-jira-filter-icon-container">
            {jiraTableHeaders.includes(field) ? (
              <img
                src="/sysGuardIcons/filter_list_gray.svg"
                alt="Filter icon"
                className="filter-icon-gray"
              />
            ) : (
              <span className="filter-applied-dot" title="Filter Applied" />
            )}
          </div>
        )}
      </div>
    );
  };

const AdaptiveHeader = ({ field, full, short, title }) => {
  const apiRef = useGridApiContext();

  const col = apiRef.current.getColumn(field);
  const width = col?.computedWidth || 0;

  const label = width < 140 ? short : full;

  return (
    <span title={title || full} className="header-title-netSpace">
      {label}
    </span>
  );
};

export const formatNumberUS = (value) => {
  if (value === null || value === undefined || value === "") return "";

  const num = typeof value === "string" ? Number(value) : value;

  if (isNaN(num)) return value; // fallback for non-numeric strings

  return new Intl.NumberFormat("en-US").format(num);
};

export const NetSpaceTableColumns = ({
  renderHostIP,
  activeFilterField,
  filterState,
  handleFilterIconClick,
  isSmall,
  group,
  dispatch,
}) => [
  {
    field: "Hostname",
    flex: 7,
    sortable: false,
    align: "center",
    headerAlign: "center",
    headerClassName: "site-map-header",
    hideable: false,
    renderCell: renderHostName,
    renderHeader: renderHeaderWithFilter(
      "Host Name",
      "hostName",
      filterState?.hostName?.length > 0,
      activeFilterField,
      handleFilterIconClick,
      isSmall,
    ),
  },
  {
    field: "IP",
    flex: 7,
    sortable: false,
    align: "center",
    headerAlign: "center",
    headerClassName: "site-map-header",
    renderCell: renderHostIP,
    hideable: false,
    renderHeader: renderHeaderWithFilter(
      "Host IP",
      "IP",
      filterState?.IP?.length > 0,
      activeFilterField,
      handleFilterIconClick,
      isSmall,
    ),
  },
  {
    field: "MacAddress",
    flex: 6.5,
    sortable: false,
    align: "center",
    headerAlign: "center",
    headerClassName: "site-map-header",
    hideable: false,
    renderCell: renderHostMacAddress,
    renderHeader: renderHeaderWithFilter(
      "MAC Address",
      "macAddress",
      filterState?.macAddress?.length > 0,
      activeFilterField,
      handleFilterIconClick,
      isSmall,
    ),
  },
  {
    field: "cveId",
    flex: 10,
    sortable: false,
    align: "center",
    headerAlign: "center",
    headerClassName: "site-map-header",
    renderCell: renderCVEId,
    renderHeader: () => (
      <span className="header-title-netSpace" title="Vulnerabilities">
        Vulnerabilities
      </span>
    ),
  },
  {
    field: "cveScore",
    flex: 2.8,
    sortable: false,
    align: "center",
    headerAlign: "center",
    headerClassName: "site-map-header",
    renderCell: renderCVEScore,
    renderHeader: () => (
      <AdaptiveHeader
        full="Vulnerabilities Score"
        short="VS"
        title="Vulnerabilities Score"
      />
    ),
  },
  {
    field: "cveSeverity",
    flex: 2.5,
    sortable: false,
    align: "center",
    headerAlign: "center",
    headerClassName: "site-map-header",
    renderCell: renderCVESeverity,
    renderHeader: () => (
      <AdaptiveHeader
        full="Vulnerabilities Total"
        short="VT"
        title="Vulnerabilities Total"
      />
    ),
  },
  {
    field: "OS",
    flex: 4,
    sortable: false,
    align: "center",
    headerAlign: "center",
    headerClassName: "site-map-header",
    renderCell: renderOS,
    renderHeader: renderHeaderWithFilter(
      "OS",
      "osName",
      filterState?.osName?.length > 0,
      activeFilterField,
      handleFilterIconClick,
      isSmall,
    ),
  },
  {
    field: "System Tags",
    flex: 6,
    sortable: false,
    align: "center",
    headerAlign: "center",
    headerClassName: "site-map-header",
    renderHeader: () => (
      <span className="header-title-netSpace">System Tags</span>
    ),
    renderCell: renderTags,
  },
  {
    field: "alertSegregation",
    flex: 5.5,
    sortable: false,
    align: "center",
    headerAlign: "center",
    headerClassName: "site-map-header",
    headerName: "Security Alerts",
    renderHeader: () => (
      <span className="header-title-netSpace table" title="Security Alerts">
        Security Alerts
      </span>
    ),
    renderCell: renderAlerts,
  },
  {
    field: "sourceType",
    flex: 4,
    sortable: false,
    align: "center",
    headerAlign: "center",
    headerClassName: "site-map-header",
    headerName: "Source Type",
    hideable: false,
    renderHeader: () => (
      <span className="header-title-netSpace table" title="Agents">
        Agents
      </span>
    ),
    renderCell: renderSource,
  },
  {
    field: "Is Monitored",
    flex: 2,
    sortable: false,
    align: "center",
    headerAlign: "center",
    headerClassName: "site-map-header",
    renderCell: renderIsMonitored,
    renderHeader: renderHeaderWithFilter(
      "Visibility",
      "visibility",
      filterState?.visibility?.length > 0,
      activeFilterField,
      handleFilterIconClick,
      isSmall,
    ),
  },
  {
    field: "Type",
    flex: 4,
    sortable: false,
    align: "center",
    headerAlign: "center",
    headerClassName: "site-map-header",
    renderCell: (params) => renderHostType(params, "tableView", isSmall),
    renderHeader: renderHeaderWithFilter(
      "Type",
      "hostType",
      filterState?.hostType?.length > 0,
      activeFilterField,
      handleFilterIconClick,
      isSmall,
    ),
  },
  {
    field: "User Tags",
    flex: 6,
    sortable: false,
    align: "center",
    headerAlign: "center",
    headerClassName: "site-map-header",
    renderHeader: () => (
      <span className="header-title-netSpace table" title="User Tags">
        User Tags
      </span>
    ),
    renderCell: (params) =>
      renderUserTagsWithHostTag(params, group, dispatch, "table"),
  },
  {
    field: "Ports",
    flex: 4.2,
    sortable: false,
    align: "center",
    headerAlign: "center",
    headerClassName: "site-map-header",
    cellClassName: "port-header",
    renderHeader: () => (
      <span className="header-title-netSpace table" title="Ports">
        Ports
      </span>
    ),
    renderCell: (params) => renderPorts(params, "table", isSmall),
  },
];

export const NetSpaceSecondDropdown = ({
  anchorEl,
  loc,
  onClose,
  onSelect,
}) => {
  const dispatch = useDispatch();
  const userTagsDropDownValues = useSelector(
    (state) => state.NetspaceReducer.userTagDropdownValues,
  );
  const systemTagsDropDownValues = useSelector(
    (state) => state.NetspaceReducer.systemTagDropdownValues,
  );

  const getDropDwnValues = (loc) => {
    if (loc === USER_TAGS) return userTagsDropDownValues || [];
    if (loc === SYSTEM_TAGS) return systemTagsDropDownValues || [];
    return [];
  };

  const handleMenuItemClick = (item) => {
    console.log("Selected item:", item);
    dispatch({
      type: GET_TAG_VALUES,
      payload: { selectedTag: loc, secondTag: item.code },
    });
    dispatch({
      type: SET_SECOND_TAG_VALUE,
      payload: item.code,
    });
    if (onSelect) {
      onSelect(item.code);
    }

    onClose();
  };

  const open = Boolean(anchorEl);
  const dropdownValues = getDropDwnValues(loc).filter((item) => item.code);

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="right-start"
      disablePortal={false}
      modifiers={[
        { name: "zIndex", enabled: true },
        {
          name: "offset",
          options: {
            offset: [10, 0],
          },
        },
      ]}
      style={{ zIndex: 1500, left: 17 }}
    >
      <ClickAwayListener onClickAway={onClose}>
        <Paper className="netspace-dropdown-content">
          {dropdownValues.length > 0 ? (
            dropdownValues.map((item) => (
              <MenuItem
                key={item.code}
                onClick={() => handleMenuItemClick(item)}
              >
                {item.code} ({item.count})
              </MenuItem>
            ))
          ) : (
            <div style={{ padding: 8 }}>No options available</div>
          )}
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
};
